module.exports = __webpack_public_path__ + "assets/img/editTagIcon.3b6329d5.png";